// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"708":"component---src-pages-404-js","936":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"612":"e400587ac5c5d7d76799","708":"c442bfe318e002ddb7f4","936":"3883baf5def07ddec319"}[chunkId] + ".js";
};